var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBuildIcon = function SvgBuildIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 46.5C35.7025 46.5 46 36.2025 46 23.5C46 10.7975 35.7025 0.5 23 0.5C10.2975 0.5 0 10.7975 0 23.5C0 36.2025 10.2975 46.5 23 46.5ZM13.5012 10.5922C16.627 9.06807 20.5149 9.59765 23.1112 12.1939C25.5524 14.6352 26.1724 18.2001 24.9841 21.2227L35.2141 31.4656C36.5445 32.7831 36.5445 34.9272 35.2141 36.2577C33.8966 37.5881 31.7524 37.5881 30.422 36.2577L20.1403 25.976C17.1566 27.0997 13.6432 26.4668 11.2407 24.0643C8.64449 21.4681 8.1149 17.606 9.62615 14.4672L14.3149 19.156C14.8187 19.6727 15.6324 19.6727 16.1362 19.156L18.1899 17.1022C18.6937 16.5985 18.6937 15.7847 18.1899 15.281L13.5012 10.5922Z",
    fill: "#2E0DA6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBuildIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "build-icon.0264036bfc8ec30ee63a7bb0990d3a1e.svg";